import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/motivos-de-cancelacion-de-cargo';

/**
 * GET Motivos De Cancelacion De Cargo
 * @returns {Promise<Array<object>>}
 */
export const getMotivosDeCancelacionDeCargo = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Motivo De Cancelacion De Cargo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMotivoDeCancelacionDeCargo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Motivo De Cancelacion De Cargo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotivoDeCancelacionDeCargo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motivo De Cancelacion De Cargo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotivoDeCancelacionDeCargo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motivo De Cancelacion De Cargo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMotivoDeCancelacionDeCargo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
